import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const medicineRoleRoutes = [
  {
    path: "/directories/medicine-role",
    name: "MedicineRoleList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "medicineRole" */ "./components/List"),
  },
];
